import React from 'react'
import { Link } from 'react-router-dom'
import BannerImg from '../../assets/landing.svg'
import valueCard from '../../assets/values_card.png'
import { values_card_1, values_card_2, values_card_3, values_card_4, values_card_5 } from '../../assets/updated_assests/assets'


const JoinWest = () => {
    return (
        <div className=' h-auto md:h-[1050px]  !bg-cover !bg-bottom md:mt-32 -mt-16 !bg-no-repeat' style={{ background: `url(${BannerImg})` }}  >
            <div className="banner w-full min-h-[300px] px-4 flex justify-center items-center !bg-cover !bg-no-repeat text-center"  >
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-[1250px] mx-auto  z-10">
                    <div className="md:block hidden">
                        <img
                            src={values_card_2}
                            className=" lg:max-w-[310px] w-full h-auto md:block md:mt-32 "
                            alt=""
                        />
                    </div>
                    <div className="">
                        <h3 className='text-dark font-roboto-mono font-bold italic md:text-[40px] text-[25px] text-center mx-auto max-w-[450px]' >
                            Join the <br /> Westbreeze Tribe
                        </h3>
                        <p className='text-dark font-quicksand font-medium text-[16px] text-center mx-auto max-w-[500px]' >Unite with passionate travelers, earn perks on your adventures, and unlock exclusive rewards. The more you explore, the more you earn - that’s the way of the Tribe!</p>
                        <div className="text-center flex justify-center mt-5 ">
                            <Link to='/login' >
                                <button className='flex  items-center gap-3 border-2 border-dark px-5 py-3 font-quicksand text-dark font-bold text-[16px] bg-white mb-5 ' >
                                    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11.2501 12.0001L18.3251 4.9251C18.5251 4.7251 18.7584 4.6251 19.0251 4.6251C19.2918 4.6251 19.5251 4.7251 19.7251 4.9251C19.9251 5.1251 20.0251 5.35843 20.0251 5.6251C20.0251 5.89176 19.9251 6.1251 19.7251 6.3251L12.6751 13.4001L11.2501 12.0001ZM13.7251 14.4751L20.0751 8.1001C20.2751 7.9001 20.5126 7.8001 20.7876 7.8001C21.0626 7.8001 21.3001 7.9001 21.5001 8.1001C21.7001 8.3001 21.8001 8.5376 21.8001 8.8126C21.8001 9.0876 21.7001 9.3251 21.5001 9.5251L15.1501 15.8751L13.7251 14.4751ZM5.7751 19.2251C4.25843 17.7084 3.5001 15.8834 3.5001 13.7501C3.5001 11.6168 4.25843 9.79176 5.7751 8.2751L8.7751 5.2751L10.2501 6.7501C10.3668 6.86676 10.4668 6.9876 10.5501 7.1126C10.6334 7.2376 10.7168 7.36676 10.8001 7.5001L14.5001 3.7751C14.7001 3.5751 14.9376 3.4751 15.2126 3.4751C15.4876 3.4751 15.7251 3.5751 15.9251 3.7751C16.1251 3.9751 16.2251 4.2126 16.2251 4.4876C16.2251 4.7626 16.1251 5.0001 15.9251 5.2001L11.6001 9.5251L9.4751 11.6251L9.9501 12.1001C10.7168 12.8668 11.0834 13.7834 11.0501 14.8501C11.0168 15.9168 10.6084 16.8418 9.8251 17.6251L8.4001 16.2251C8.78343 15.8418 8.99593 15.3876 9.0376 14.8626C9.07926 14.3376 8.90843 13.8834 8.5251 13.5001L7.3501 12.3501C7.1501 12.1501 7.0501 11.9126 7.0501 11.6376C7.0501 11.3626 7.1501 11.1251 7.3501 10.9251L8.7751 9.5251C8.9751 9.3251 9.0751 9.0876 9.0751 8.8126C9.0751 8.5376 8.9751 8.3001 8.7751 8.1001L7.1751 9.7001C6.04176 10.8334 5.4751 12.1876 5.4751 13.7626C5.4751 15.3376 6.04176 16.6918 7.1751 17.8251C8.30843 18.9584 9.66676 19.5251 11.2501 19.5251C12.8334 19.5251 14.1918 18.9584 15.3251 17.8251L21.3001 11.8251C21.5001 11.6251 21.7376 11.5251 22.0126 11.5251C22.2876 11.5251 22.5251 11.6251 22.7251 11.8251C22.9251 12.0251 23.0251 12.2626 23.0251 12.5376C23.0251 12.8126 22.9251 13.0501 22.7251 13.2501L16.7251 19.2251C15.2084 20.7418 13.3834 21.5001 11.2501 21.5001C9.11676 21.5001 7.29176 20.7418 5.7751 19.2251ZM17.5001 23.5251V21.5001C18.6001 21.5001 19.5418 21.1084 20.3251 20.3251C21.1084 19.5418 21.5001 18.6001 21.5001 17.5001H23.5251C23.5251 19.1668 22.9376 20.5876 21.7626 21.7626C20.5876 22.9376 19.1668 23.5251 17.5001 23.5251ZM1.4751 7.5001C1.4751 5.83343 2.0626 4.4126 3.2376 3.2376C4.4126 2.0626 5.83343 1.4751 7.5001 1.4751V3.5001C6.4001 3.5001 5.45843 3.89176 4.6751 4.6751C3.89176 5.45843 3.5001 6.4001 3.5001 7.5001H1.4751Z" fill="#25231B" />
                                    </svg>
                                    Join our Tribe </button>
                            </Link>

                        </div>
                    </div>
                    <div className="md:flex justify-end h-fit hidden">
                        <img
                            src={values_card_1}
                            className="  md:-mt-20  lg:max-w-[310px] w-full h-auto"
                            alt=""
                        /></div>
                </div>


            </div>
            <div className="md:mb-0 md:mt-0 -mt-6">
                <div className="grid grid-cols-3 gap-4 max-w-[1250px] mx-auto  md:px-0 px-10  z-10">
                    <div className="">
                        <img
                            src={values_card_5}
                            className=" lg:max-w-[310px] w-full h-auto md:block md:mt-[15rem] md:ml-[4rem] mt-2  "
                            alt=""
                        />
                    </div>
                    <div className="">
                        <img
                            src={values_card_3}
                            className=" lg:max-w-[310px] w-full h-auto md:block lg:-mt-[6rem] mt-2  "
                            alt=""
                        />
                    </div>

                    <div className="">
                        <img
                            src={values_card_4}
                            className=" lg:max-w-[310px] w-full h-fit md:block md:mt-[4rem] mt-2  "
                            alt=""
                        />
                    </div>
                </div>
                <div className="grid grid-cols-2  md:hidden gap-4 max-w-[70%] mx-auto md:my-0 my-4 md:px-0 px-10  z-10">

                    <div className="">
                        <img
                            src={values_card_2}
                            className=" lg:max-w-[310px] w-full h-auto md:block md:mt-[15rem] md:ml-[4rem] mt-2  "
                            alt=""
                        />
                    </div>
                    <div className="">
                        <img
                            src={values_card_1}
                            className=" lg:max-w-[310px] w-full h-auto md:block lg:-mt-[6rem] mt-2  "
                            alt=""
                        />
                    </div>
                </div>
            </div>







        </div>
    )
}

export default JoinWest
